import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=137c8201&"
import script from "./ImageText.vue?vue&type=script&lang=js&"
export * from "./ImageText.vue?vue&type=script&lang=js&"
import style0 from "./ImageText.vue?vue&type=style&index=0&id=137c8201&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports